const socketIo = require('socket.io-client');

(function () {
  let socket = null;
  let promises = [];

  const excludedDomains = /^.*.(lazarangelov|andreiabrazier|jenselter).diet$/;

  if (backEndVars.webSocketServerUrl && !window.location.hostname.match(excludedDomains)) {
    socket = socketIo.connect(backEndVars.webSocketServerUrl, {
      transports: ['websocket', 'polling'],
      upgrade: true,
      secure: true,
      reconnect: true,
    });
  }

  const pushPromise = promise => {
    promises.push(promise);
  };

  /**
   * Event constructor.
   *
   * @param trackingData
   */
  const event = (trackingData = {}) => {
    let date = Date.now();

    return {
      id: trackingData.customerUuid + '_' + trackingData.eventType + '_' + date,
      type: trackingData.eventType,
      system: trackingData.systemType,
      uri: trackingData.uri,
      domain: trackingData.domain,
      email: trackingData.email,
      phone: trackingData.phone,
      customerUuid: trackingData.customerUuid,
      data: trackingData.additionalData,
      utmParams: trackingData.utmParams,
      createdAt: date,
    };
  };

  /**
   * Track all events via web socket.
   *
   * @param events
   */
  const trackClient = (...events) => {
    if (!socket) {
      return;
    }

    events.forEach(function (event) {
      Promise.all(promises).then(function () {
        promises = [];

        socket.emit('track', {
          id: event.id,
          type: event.type,
          system: event.system,
          uri: event.uri,
          domain: event.domain,
          email: event.email,
          phone: event.phone,
          customerUuid: event.customerUuid,
          data: event.data,
          date: event.createdAt,
          utm: event.utmParams,
          meta: {
            facebook: {
              clientId: getFbClientId(),
              clickId: getFbClickId(),
            },
            googleAnalytics: {
              clientId: null,
            },
            twitter: {
              clickId: getTwClickId(),
            },
            googleAds: {
              clickId: getGClickId(),
            },
            tapfiliate: {
              refId: getRefId(),
            },
          },
        });
      });
    });
  };

  const getFbClientId = () => {
    let facebookClientId = /_fbp=(fb\.[0-2]\.\d+\.\d+)/.exec(window.document.cookie);

    if (!(facebookClientId && facebookClientId[1])) {
      return null;
    }

    return facebookClientId[1];
  };

  const getFbClickId = () => {
    let facebookClickId = /_fbc=(fb\.[0-2]\.\d+\.([A-Za-z0-9._~-]+))/.exec(window.document.cookie);
    if (!(facebookClickId && facebookClickId[1])) {
      return null;
    }

    return facebookClickId[1];
  };

  const getTwClickId = () => {
    return store.get('__twclid');
  };

  const getGClickId = () => {
    return store.get('__gclid');
  };

  const getRefId = () => {
    return store.get('__rid');
  };

  window.tracking = {
    event,
    getFbClientId,
    getFbClickId,
    getTwClickId,
    getGClickId,
    getRefId,
    pushPromise,
    trackClient,
  };
})();
